<template>
    <div :id="pb_mapUid_s"
         :style="{'zIndex': gv_zIndex.tqLeafLet_map}">
    </div>
</template>

<script>

    import L from 'leaflet'
    import 'mapbox-gl-leaflet'
    import { GestureHandling } from "leaflet-gesture-handling";

    import {svg_getMarkerHtml_s} from "../../scripts/S_Svg";
    import {gv_zIndex} from "../../scripts/S_GlobalVar";
    import {enum_langCodes, mapTilerStyles_s} from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb, validator_null_fb, validator_class_fb,} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        ass_img_locationDot_gray,
        ass_img_locationDot_green
    } from "../../assets/scripts/Ass_Files";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {helper_getMapTilerStyle_f} from "../../scripts/S_Helper";
    import {date_newDate_fd} from "../../scripts/S_Date";
    import {FB_MapPoint, FB_UserGeoLocation} from "../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "tqLeafletDisplaySimple",
        props:{

            // require values
            pb_mapUid_s : {
                type: String,
                default: "mapid"
            },
            p_display_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },

            // setting map
            pb_centerMap_c : {
                type: FB_MapPoint,
                require: true
            },
            pb_zoom_n:{
                type: Number,
                require: true
            },

            // paint on map
            p_markers_ac:{
                type: Array,
                default() {
                    return []
                }
            },

            // players locations
            p_currentUserLocation_c:{
                type:FB_UserGeoLocation,
                default: null,
                validator(val){
                    return validator_null_fb(val) || validator_class_fb(val, FB_UserGeoLocation)
                }
            },

            // change behavior
            pf_twoFingersMovement_b:{
                type: Boolean,
                default: true
            },

            // functions
            pe_onClickMarker_f: {
                type: Function,
                default() {
                    return () => {}
                }
            },
            pe_changeBonds_f:{
                type: Function,
            }
        },
        data(){
            return {
                mymap_l     : null,
                gv_zIndex   : gv_zIndex,

                displayedRectanglesImagesIndexes_an : [],

                currentLocation_marker_l : null,
                playerLocation_al : [],
                playerLocation_accuracy_al : [],
                playerLocation_names_al : [],
            }
        },
        methods:{
            m_drawMarker_f(index_n, location_c, markerColor_s, text_s){

                // 1) MARKER ICON
                let riddleMarker_l = L.marker(
                    [location_c.mp_lat_n, location_c.mp_lng_n],
                    {
                        icon: L.divIcon({
                            className: "",
                            html        : svg_getMarkerHtml_s(markerColor_s),
                            iconSize: [38, 95],     // size of the icon
                        }),
                    })
                    .addTo(this.mymap_l)

                // 2) TEXT
                if (text_s != null) {
                    riddleMarker_l.bindPopup(text_s, {offset: L.point(0, -30)})
                }

                // 3) MARKER On Click Event
                riddleMarker_l.on('click', (e) => {
                    this.pe_onClickMarker_f(index_n)
                })

            },
            m_refresh_currentUserLocation_f(){
                
            },
            m_cbBounds_f(){
                let bounds_o = this.mymap_l.getBounds()
                let maxLat = bounds_o._northEast.lat
                let maxLng = bounds_o._northEast.lng
                let minLat = bounds_o._southWest.lat
                let minLng = bounds_o._southWest.lng
                this.pe_changeBonds_f(minLat,minLng, maxLat,maxLng)
            },
            m_setMarkers_f(){
                this.p_markers_ac.forEach((marker_c, index) => {
                    this.m_drawMarker_f(index, marker_c.ltm_location_c, marker_c.ltm_color_s, marker_c.ltm_text_s)
                })
            }
        },

        // life circle
        watch:{
            p_currentUserLocation_c :{
                handler(){
                    this.m_refresh_currentUserLocation_f()
                },
                deep: true,
            },
            p_markers_ac : {
                handler(){
                   this.m_setMarkers_f()
                },
                deep: true,}
        },
        mounted(){

            // 1) init map
            this.mymap_l = L.map(this.pb_mapUid_s, {
                attributionControl : false,
                gestureHandling    : this.pf_twoFingersMovement_b,
            })
            if(this.pf_twoFingersMovement_b){
                L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
            }

            // 2) set map type
            // let gl = L.mapboxGL({
            //     style       : helper_getMapTilerStyle_f(this.p_display_langCode_e),
            //     maxzoom : 10,
            // }).addTo(this.mymap_l);


            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 20,
                maxNativeZoom: 18,
            }).addTo(this.mymap_l);


            // 3) settings
            this.mymap_l.keyboard.disable();
            this.mymap_l.setView([this.pb_centerMap_c.mp_lat_n, this.pb_centerMap_c.mp_lng_n], this.pb_zoom_n);



            if(this.pe_changeBonds_f){
                this.m_cbBounds_f()
                this.mymap_l.on('moveend', this.m_cbBounds_f);
            }

            // 7) refresh player location
            this.m_refresh_currentUserLocation_f()

            // 8)
            this.m_setMarkers_f()

        },
    }


</script>

<style scoped>

</style>